import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'

/** Branded error screen for any route: never show the React Router dev page. */
export function RouteError() {
  const error = useRouteError()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const status = isRouteErrorResponse(error) ? error.status : null
  if (import.meta.env.DEV) console.error(error)
  return (
    <div role="alert" style={{ padding: '48px 24px', textAlign: 'center', color: 'var(--color-text-primary)' }}>
      <AlertTriangle size={32} aria-hidden style={{ color: 'var(--color-warning, #F59E0B)' }} />
      <h1 style={{ fontSize: 20, margin: '16px 0 8px' }}>{t('mobile.routeError.title')}</h1>
      <p style={{ color: 'var(--color-text-secondary)', marginBottom: 24 }}>
        {status ? t('mobile.routeError.status', { status }) : t('mobile.routeError.body')}
      </p>
      <button type="button" onClick={() => void navigate('/', { replace: true })}
        style={{ minHeight: 44, padding: '0 20px', borderRadius: 8, background: 'var(--color-accent)', color: 'var(--color-accent-fg)', border: 0 }}>
        {t('mobile.routeError.home')}
      </button>
    </div>
  )
}
